<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>专职人员管理</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 搜索筛选 -->
    <el-form :inline="true" :model="searchUser" class="user-search">
      <el-form-item prop="hospitalLevel" label="医院名称：" v-show="hShow">
        <el-select clearable filterable size="small" style="width: 130%" v-model="searchUser.hospitalNumber"
          placeholder="请选择医院">
          <el-option v-for="item in hospitalData" :key="item.HospitalNumber" :label="item.HospitalName"
            :value="item.HospitalNumber">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="用户名：">
        <el-input clearable size="small" v-model="searchUser.name" placeholder="输入用户名"></el-input>
      </el-form-item>
      <el-form-item label="手机号：">
        <el-input clearable size="small" v-model="searchUser.phone" placeholder="输入手机号"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" size="small" icon="el-icon-search" @click="search">搜索</el-button>
        <el-button type="primary" size="small" icon="el-icon-plus" @click="addDialog = true">添加</el-button>
      </el-form-item>
    </el-form>
    <!--列表-->
    <el-table size="small" :data="userData.slice((page - 1) * pagesize, page * pagesize)" highlight-current-row
      v-loading="loading" element-loading-text="加载中" element-loading-spinner="el-icon-loading"
      element-loading-background="rgba(0, 0, 0, 0.8)" border style="width: 100%">
      <el-table-column fixed align="center" sortable prop="UserID" label="用户编号" width="150">
      </el-table-column>
      <el-table-column fixed align="center" sortable prop="Name" label="姓名" width="150">
      </el-table-column>
      <el-table-column fixed align="center" sortable prop="idNumber" label="身份证号" width="150">
      </el-table-column>
      <el-table-column align="center" sortable prop="bornDate" label="出生日期" width="150">
      </el-table-column>
      <el-table-column align="center" sortable prop="Gender" label="性别" width="150">
      </el-table-column>
      <el-table-column align="center" sortable prop="Age" label="年龄" width="150">
      </el-table-column>
      <el-table-column align="center" sortable prop="Phone" label="联系电话" width="150">
      </el-table-column>
      <el-table-column align="center" sortable prop="profession" label="所学专业" width="150">
      </el-table-column>
      <el-table-column align="center" sortable label="参加院感工作日期" width="150">
        <template slot-scope="scope">
          {{ scope.row.startDate.split("T")[0] }}
        </template>
      </el-table-column>
      <el-table-column align="center" sortable label="从事院感年限" width="150">
        <template slot-scope="scope">
          {{ scope.row.NX }}
        </template>
      </el-table-column>
      <el-table-column align="center" sortable prop="Duties" label="职务" width="150">
      </el-table-column>
      <el-table-column align="center" sortable prop="zc" label="取得的职称" width="150">
      </el-table-column>
      <el-table-column align="center" sortable prop="Train" label="近一年是否参加感染控制培训" width="220">
      </el-table-column>
      <el-table-column align="center" sortable label="上一次参加感控培训等级" width="230">
        <template slot-scope="scope">
          {{ scope.row.Certificate }}
        </template>
      </el-table-column>
      <el-table-column align="center" sortable label="上一次参加市级以上感控培训时间" width="230">
        <template slot-scope="scope">
          <label v-if="scope.row.lastTraining.includes('1900')"></label>
          <label v-else> {{ scope.row.lastTraining.split("T")[0] }}</label>
        </template>
      </el-table-column>
      <el-table-column fixed="right" label="操作" min-width="350">
        <template slot-scope="scope">
          <el-button size="mini" @click="editPerson(scope.row)">编辑</el-button>
          <el-button size="mini" type="danger" @click="delPerson(scope.row)">删除</el-button>
          <el-button size="mini" type="success" @click="checkZS(scope.row)">查看证书</el-button>
          <el-button size="mini" type="primary" @click="checkFJ(scope.row)"
            v-if="scope.row.FileName != ''">查看附件</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination @current-change="pageChange" :current-page.sync="page" :page-size="pagesize"
      layout="prev, pager, next, jumper" :total="userData.length">
    </el-pagination>

    <el-dialog title="人员编辑" :visible.sync="editDialog" :before-close="handleClose" width="45%">
      <el-form label-position="right" :model="person" :rules="personRules" ref="person" label-width="150px"
        class="demo-ruleForm login-container">
        <el-form-item prop="userID" label="用户编号">
          <el-input disabled type="text" v-model="person.userID" placeholder="请输入用户编号"></el-input>
        </el-form-item>
        <el-form-item prop="name" label="姓名">
          <el-input type="text" v-model="person.name" placeholder="请输入姓名"></el-input>
        </el-form-item>
        <el-form-item label="身份证号">
          <el-input type="text" v-model="person.idNumber" placeholder="请输入身份证号"></el-input>
        </el-form-item>
        <el-form-item prop="gender" label="性别">
          <el-radio v-model="person.gender" label="男">男</el-radio>
          <el-radio v-model="person.gender" label="女">女</el-radio>
        </el-form-item>
        <el-form-item prop="bornDate" label="出生日期">
          <el-date-picker v-model="person.bornDate" type="date" style="width: 100%" @change="bornDateChange"
            placeholder="选择出生日期" format="yyyy-MM-dd" value-format="yyyy-MM-dd">
          </el-date-picker>
        </el-form-item>
        <el-form-item prop="age" label="年龄">
          <el-input-number v-model="person.age" :min="1" :max="120"></el-input-number>
        </el-form-item>
        <el-form-item prop="phone" label="联系电话">
          <el-input type="text" v-model="person.phone" placeholder="请输入联系电话"></el-input>
        </el-form-item>
        <el-form-item prop="profession" label="所学专业">
          <el-select clearable filterable style="width: 100%" v-model="person.profession" placeholder="请选择所学专业">
            <el-option v-for="item in professional" :key="item.ID" :label="item.name" :value="item.name">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="startDate" label="参加院感工作日期">
          <el-date-picker v-model="person.startDate" type="date" placeholder="选择日期" style="width: 100%"
            value-format="yyyy-MM-dd">
          </el-date-picker>
        </el-form-item>
        <el-form-item prop="duties" label="职务" v-if="person.profession != '公共事业管理'">
          <el-select clearable filterable style="width: 100%" v-model="person.duties" placeholder="请选择职务">
            <el-option v-for="item in allDuties" :key="item.DutiesName" :label="item.DutiesName"
              :value="item.DutiesName">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="zc" label="取得的职称" v-if="person.profession != '公共事业管理'">
          <el-select clearable filterable style="width: 100%" v-model="person.zc" placeholder="请选择取得的职称">
            <el-option v-for="item in professionalPost" :key="item.ID" :label="item.name" :value="item.name">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="train" label="近一年是否参加感染控制培训">
          <el-radio v-model="person.train" label="是">是</el-radio>
          <el-radio v-model="person.train" label="否">否</el-radio>
        </el-form-item>
        <el-form-item prop="certificate" v-if="person.train == '是'" label="上一次参加感控培训等级">
          <el-radio v-model="person.certificate" label="省级">省级</el-radio>
          <el-radio v-model="person.certificate" label="市级">市级</el-radio>
        </el-form-item>
        <el-form-item prop="lastTraining" label="上一次参加市级以上感控培训时间">
          <el-date-picker v-model="person.lastTraining" type="date" placeholder="选择日期" style="width: 100%"
            value-format="yyyy-MM-dd">
          </el-date-picker>
        </el-form-item>
        <el-form-item prop="scfj" label="上一次参加市级以上感控培训附件">
          <el-upload :action="uploadFileUrl + 'Upload/UploadFullTimeFile'" ref="upload" list-type="picture-card"
            :on-success="uploadSuccess" :auto-upload="false">
            <i slot="default" class="el-icon-plus"></i>
            <div slot="file" slot-scope="{ file }">
              <img class="el-upload-list__item-thumbnail" :src="file.url" alt="" />
              <span class="el-upload-list__item-actions">
                <span class="el-upload-list__item-preview" @click="handlePictureCardPreview(file)">
                  <i class="el-icon-zoom-in"></i>
                </span>
                <span v-if="!disabled" class="el-upload-list__item-delete" @click="handleDownload(file)">
                  <i class="el-icon-download"></i>
                </span>
                <span v-if="!disabled" class="el-upload-list__item-delete" @click="handleRemove(file)">
                  <i class="el-icon-delete"></i>
                </span>
              </span>
            </div>
          </el-upload>
          <el-dialog :visible.sync="dialogVisible2">
            <img width="100%" :src="dialogImageUrl" alt="" />
          </el-dialog>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" style="width: 100%" @click="submitUpload('edit')" :loading="loading">提交</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>

    <el-dialog title="人员添加" :visible.sync="addDialog" :before-close="handleClose" width="45%">
      <el-form label-position="right" :model="person" :rules="personRules" ref="person" label-width="150px"
        class="demo-ruleForm login-container">
        <el-form-item prop="name" label="姓名">
          <el-input type="text" v-model="person.name" placeholder="请输入姓名" @change="nameChange()"></el-input>
        </el-form-item>
        <el-form-item label="身份证号">
          <el-input type="text" v-model="person.idNumber" placeholder="请输入身份证号"></el-input>
        </el-form-item>
        <el-form-item prop="gender" label="性别">
          <el-radio v-model="person.gender" label="男">男</el-radio>
          <el-radio v-model="person.gender" label="女">女</el-radio>
        </el-form-item>
        <el-form-item prop="bornDate" label="出生日期">
          <el-date-picker v-model="person.bornDate" type="date" style="width: 100%" @change="bornDateChange"
            placeholder="选择出生日期" format="yyyy-MM-dd" value-format="yyyy-MM-dd">
          </el-date-picker>
        </el-form-item>
        <el-form-item prop="age" label="年龄">
          <el-input-number v-model="person.age" :min="1" :max="120"></el-input-number>
        </el-form-item>
        <el-form-item prop="phone" label="联系电话">
          <el-input type="text" v-model="person.phone" placeholder="请输入联系电话"></el-input>
        </el-form-item>
        <el-form-item prop="profession" label="所学专业">
          <el-select clearable filterable style="width: 100%" v-model="person.profession" placeholder="请选择所学专业">
            <el-option v-for="item in professional" :key="item.ID" :label="item.name" :value="item.name">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="startDate" label="参加院感工作日期">
          <el-date-picker v-model="person.startDate" type="date" placeholder="选择日期" style="width: 100%"
            value-format="yyyy-MM-dd">
          </el-date-picker>
        </el-form-item>
        <el-form-item prop="duties" label="职务" v-if="person.profession != '公共事业管理'">
          <el-select clearable filterable style="width: 100%" v-model="person.duties" placeholder="请选择职务">
            <el-option v-for="item in allDuties" :key="item.DutiesName" :label="item.DutiesName"
              :value="item.DutiesName">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="zc" label="取得的职称" v-if="person.profession != '公共事业管理'">
          <el-select clearable filterable style="width: 100%" v-model="person.zc" placeholder="请选择取得的职称">
            <el-option v-for="item in professionalPost" :key="item.ID" :label="item.name" :value="item.name">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="train" label="近一年是否参加感染控制培训">
          <el-radio v-model="person.train" label="是">是</el-radio>
          <el-radio v-model="person.train" label="否">否</el-radio>
        </el-form-item>
        <el-form-item prop="certificate" v-if="person.train == '是'" label="上一次参加感控培训等级">
          <el-radio v-model="person.certificate" label="省级">省级</el-radio>
          <el-radio v-model="person.certificate" label="市级">市级</el-radio>
        </el-form-item>
        <el-form-item prop="lastTraining" label="上一次参加市级以上感控培训时间">
          <el-date-picker v-model="person.lastTraining" type="date" placeholder="选择日期" style="width: 100%"
            value-format="yyyy-MM-dd">
          </el-date-picker>
        </el-form-item>
        <el-form-item prop="scfj" label="上一次参加市级以上感控培训附件">
          <el-upload :action="uploadFileUrl + 'Upload/UploadFullTimeFile'" ref="upload" list-type="picture-card"
            :on-success="uploadSuccess" :auto-upload="false">
            <i slot="default" class="el-icon-plus"></i>
            <div slot="file" slot-scope="{ file }">
              <img class="el-upload-list__item-thumbnail" :src="file.url" alt="" />
              <span class="el-upload-list__item-actions">
                <span class="el-upload-list__item-preview" @click="handlePictureCardPreview(file)">
                  <i class="el-icon-zoom-in"></i>
                </span>
                <span v-if="!disabled" class="el-upload-list__item-delete" @click="handleDownload(file)">
                  <i class="el-icon-download"></i>
                </span>
                <span v-if="!disabled" class="el-upload-list__item-delete" @click="handleRemove(file)">
                  <i class="el-icon-delete"></i>
                </span>
              </span>
            </div>
          </el-upload>
          <el-dialog :visible.sync="dialogVisible2">
            <img width="100%" :src="dialogImageUrl" alt="" />
          </el-dialog>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" style="width: 100%" @click="submitUpload('add')" :loading="loading">提交</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <el-dialog title="证书预览和下载" :visible.sync="dialogVisible" width="1000px">
      <div id="pdfDom" style="width: 100%">
        <div class="proBox">
          <p class="tit">
            <center>四川省医院感染管理质量控制中心</center>
          </p>
          <p class="con" style="position: relative; left: 470px">
            <span>第{{ zsh }}-{{ suiji }}号</span>
          </p>
          <p class="con">
            <span>恭喜</span>
            <span class="con-name">{{ userName
            }}<lable style="margin-left: 10px">({{ idNumber }})</lable></span>老师：<br />
          </p>
          <p class="con-text">入驻四川省医院感染管理专职人员库。</p>
          <p class="con-text">特发此证，以资鼓励。</p>

          <div class="con-unit">
            <p class="time">四川省医院感染管理质量控制中心</p>
            <p class="time">{{ this.zsDate }}</p>
          </div>
          <div class="chapter">
            <canvas id="chapterCanvas" width="150" height="150"></canvas>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-switch inactive-color="#67c23a" v-model="downType" active-text="图片下载" inactive-text="pdf下载"
          style="margin-right: 20px">
        </el-switch>
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="getPdf('#pdfDom')">下载</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { searchUser, addUser, editUser, delUser } from "../../api/user";
import {
  getDuties,
  getHospital,
  getProfessional,
  getProfessionalPost,
} from "../../api/hospital";
export default {
  data() {
    return {
      hospitalData: [],
      userName: "",
      idNumber: "",
      level: "高级工程师",
      //获取当前日期
      zsDate: "",
      dialogVisible: false,
      pageData: null, //接收html格式代码
      htmlTitle: "",
      isCanvas: false,
      downType: true, // false为 pdf , true为图片
      suiji: "",
      zsh: "",
      //
      addDialog: false,
      editDialog: false,
      allDuties: [],
      professional: [],
      professionalPost: [],
      nowDate: "",
      hospitalNumber: "",
      searchUser: {
        hospitalNumber: "",
        name: "",
        phone: "",
      },
      person: {
        hospitalNumber: "",
        userID: "",
        name: "",
        idNumber: "",
        phone: "",
        gender: "男",
        age: "",
        profession: "",
        startDate: "",
        zc: "",
        duties: "",
        train: "是",
        lastTraining: "",
        certificate: "",
        fileName: "",
        bornDate: "",
      },
      loading: false, //是显示加载
      userData: [],
      loginUser: {},
      page: 1,
      pagesize: 15,
      personRules: {
        hospitalNumber: [
          { required: true, message: "请选择医院", trigger: "blur" },
        ],
        bornDate: [
          { required: true, message: "请选择出生日期", trigger: "blur" },
        ],
        psw: [{ required: true, message: "请输入密码", trigger: "blur" }],
        name: [{ required: true, message: "请输入姓名", trigger: "blur" }],
        // idNumber: [
        //   { required: true, message: "请输入身份证号", trigger: "blur" },
        // ],
        gender: [{ required: true, message: "请选择性别", trigger: "blur" }],
        age: [{ required: true, message: "请输入年龄", trigger: "blur" }],
        phone: [{ required: true, message: "请输入联系电话", trigger: "blur" }],
        duties: [{ required: true, message: "请选择职务", trigger: "blur" }],
        certificate: [
          { required: true, message: "请选择感控培训等级", trigger: "blur" },
        ],
        // lastTraining: [
        //   { required: true, message: "请选择上一次参加感控培训时间", trigger: "blur" },
        // ],
        // scfj: [
        //   { required: true, message: "请选择附件", trigger: "change" },
        // ],
        startDate: [
          {
            required: true,
            message: "请选择参加院感工作日期",
            trigger: "blur",
          },
        ],
        profession: [
          { required: true, message: "请选择所学专业", trigger: "blur" },
        ],
        zc: [{ required: true, message: "请选择职称", trigger: "blur" }],
        train: [
          {
            required: true,
            message: "请选择近一年是否参加感染控制培训",
            trigger: "blur",
          },
        ],
      },
      dialogImageUrl: "",
      dialogVisible2: false,
      disabled: true,
      uploadFileUrl: "",
      hShow: true,
      permission: 0,
      submitType: ''
    };
  },
  created() {
    this.getNowDate();
    this.loginUser = JSON.parse(localStorage.getItem("userdata"))[0];
    this.searchUser.hospitalNumber = this.loginUser.HospitalNumber;
    this.uploadFileUrl = sessionStorage.getItem("baseURL");
    this.person.hospitalNumber = this.loginUser.HospitalNumber;
    this.hospitalNumber = this.loginUser.HospitalNumber;
    this.permission = this.loginUser.permission;
    this.search();
    this.getAllDuties();
    this.getProfessional();
    this.getProfessionalPost();
    this.getHospital();
    if (this.permission > 0) {
      this.hShow = true;
    } else this.hShow = false;
  },
  methods: {
    bornDateChange() {
      this.person.age = this.age(this.person.bornDate)
    },
    age(bornDate) {
      if (!bornDate) return 0;
      const today = new Date();
      const birth = new Date(bornDate);
      let age = today.getFullYear() - birth.getFullYear();
      const monthDiff = today.getMonth() - birth.getMonth();
      // 如果还没到生日，则减一岁
      if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birth.getDate())) {
        age--;
      }
      return age >= 0 ? age : 0;
    },
    uploadSuccess(response) {
      if (this.submitType == 'add') {
        if (response.status == "ok") {
          this.$message.success(response.msg);
          this.personSubmit("person", response.filePath.split("\\")[6]);
        } else this.$message.warning(response.msg);
      } else if (this.submitType == 'edit') {
        if (response.status == "ok") {
          this.$message.success(response.msg);
          this.editUser("person", response.filePath.split("\\")[6]);
        } else this.$message.warning(response.msg);
      }
      this.$refs.upload.clearFiles();
      this.load = false;
    },
    submitUpload(type) {
      this.submitType = type
      if (type == 'add') {
        if (this.person.lastTraining && this.$refs.upload.uploadFiles.length == 0) {
          this.$message.warning('请上传上一次参加市级以上感控培训附件文件')
          return
        }
        if (!this.person.lastTraining && this.$refs.upload.uploadFiles.length != 0) {
          this.$message.warning('请选择上一次参加市级以上感控培训时间')
          return
        }
        if (this.person.lastTraining && this.$refs.upload.uploadFiles.length != 0) {
          this.$refs.upload.submit()
        } else {
          this.personSubmit("person", '')
        }
      } else if (type = 'edit') {
        if (this.person.fileName == '') {
          if (this.person.lastTraining && this.$refs.upload.uploadFiles.length == 0) {
            this.$message.warning('请上传上一次参加市级以上感控培训附件文件')
            return
          }
          if (!this.person.lastTraining && this.$refs.upload.uploadFiles.length != 0) {
            this.$message.warning('请选择上一次参加市级以上感控培训时间')
            return
          }
        } else {
          if (!this.person.lastTraining) {
            this.$message.warning('请选择上一次参加市级以上感控培训时间')
            return
          }
        }
        if (this.$refs.upload.uploadFiles.length != 0) {
          this.$refs.upload.submit()
        } else {
          this.editUser("person", this.person.fileName)
        }
      }
    },
    handleRemove(file) { },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible2 = true;
    },
    handleDownload(file) { },
    getHospital() {
      getHospital({ hospitalName: "" }).then((res) => {
        this.hospitalData = []
        for (let i = 0; i < res.data.length; i++) {
          if (this.permission == 1) {
            this.hospitalData = res.data;
          } else if (this.permission == 2) {
            if (res.data[i].Area.split(',')[1] == this.loginUser.Area.split(',')[1]) {
              this.hospitalData.push(res.data[i])
            }
          } else if (this.permission == 3) {
            if (res.data[i].Area.split(',')[2] == this.loginUser.Area.split(',')[2]) {
              this.hospitalData.push(res.data[i])
            }
          }
        }
      });
    },
    //随机数
    randomNumber(len, max) {
      var arr = [];
      var result = "";
      var count = 0;
      while (count < len) {
        var n = Math.floor(Math.random() * max + 1);
        if (arr.join().indexOf(n) == -1) {
          arr.push(n);
          count++;
        }
      }
      for (let index = 0; index < arr.length; index++) {
        result = result + arr[index];
      }
      return result;
    },
    checkZS(row) {
      this.zsDate =
        row.CreateDate.split("T")[0].split("-")[0] +
        "年" +
        row.CreateDate.split("T")[0].split("-")[1] +
        "月" +
        row.CreateDate.split("T")[0].split("-")[2] +
        "日";
      this.zsh = row.HospitalNumber;
      this.suiji = row.UserID;
      this.userName = row.Name;
      this.idNumber = row.idNumber;
      this.htmlTitle = row.Name + "-证书";
      this.preview("check");
    },
    checkFJ(row) {
      window.open(
        "http://www.scyokj.com/FODDP/yygrjcptUpload/img/" + row.FileName
      );
    },
    nameChange() {
      this.userName = this.person.name;
      this.htmlTitle = this.person.name + "-证书";
    },
    preview(type) {
      var vm = this;
      //获取当前日期
      var data = new Date(new Date().setHours(0, 0, 0, 0));
      if (type != "check") {
        vm.zsDate =
          data.getFullYear() +
          "年" +
          (data.getMonth() + 1) +
          "月" +
          data.getDate() +
          "日";
      }
      this.dialogVisible = true;
      this.$nextTick(() => {
        if (!this.isCanvas) {
          // 只绘画一次
          this.isCanvas = true;
          this.getChapter();
        }
      });
    },
    delPerson(row) {
      this.$confirm("确认删除？")
        .then((_) => {
          delUser({ id: row.ID }).then((res) => {
            if (res.data > 0) {
              this.$message.success("删除成功");
              this.search();
            } else this.$message.warning("删除失败");
          });
        })
        .catch((_) => { });
    },
    handleClose(done) {
      done();
      this.person = {
        hospitalNumber: this.loginUser.HospitalNumber,
        userID: "",
        name: "",
        phone: "",
        gender: "男",
        age: "",
        profession: "",
        startDate: "",
        zc: "",
        duties: "",
        train: "是",
        lastTraining: "",
        certificate: "",
      };
    },
    editPerson(row) {
      this.person.userID = row.UserID;
      this.person.name = row.Name;
      this.person.idNumber = row.idNumber;
      this.person.gender = row.Gender;
      this.person.age = row.Age;
      this.person.phone = row.Phone;
      this.person.profession = row.profession;
      this.person.startDate = row.startDate;
      this.person.duties = row.Duties;
      this.person.train = row.Train;
      this.person.zc = row.zc;
      this.person.bornDate = row.bornDate;
      if (row.lastTraining.includes('1900')) {
        this.person.lastTraining = null
      } else {
        this.person.lastTraining = row.lastTraining;
      }
      this.person.certificate = row.Certificate;
      this.person.fileName = row.FileName;
      this.editDialog = true;
    },
    editUser(formName, fileName) {
      if (this.person.idNumber != '' && this.person.idNumber.length != 18) {
        this.$message.warning("请输入正确的身份证号");
        return;
      }
      if (this.person.bornDate == '') {
        this.$message.warning("请选择出生日期");
        return;
      }
      if (this.person.phone.length != 11) {
        this.$message.warning("请输入正确的手机号码");
        return;
      }
      if (this.person.profession == '公共事业管理') {
        this.person.duties = ''
        this.person.zc = ''
      }
      if (this.person.train == '否') {
        this.person.certificate = ''
      }
      this.person.fileName = fileName
      this.$refs[formName].validate((valid) => {
        if (valid) {
          editUser(this.person).then((res) => {
            if (res.data > 0) {
              this.$message.success("修改成功");
              this.editDialog = false;
              this.person = {
                hospitalNumber: this.loginUser.HospitalNumber,
                userID: "",
                name: "",
                phone: "",
                gender: "男",
                age: "",
                profession: "",
                startDate: "",
                zc: "",
                duties: "",
                train: "是",
                lastTraining: "",
                certificate: "",
                fileName: "",
              };
              this.search();
            } else this.$message.warning("修改失败");
          });
        } else {
          this.$message.warning("请将人员信息填写完整!")
          return false
        }
      });
    },
    search() {
      this.loading = true;
      if (this.searchUser.hospitalNumber == "") {
        this.searchUser.hospitalNumber = this.loginUser.HospitalNumber;
      }
      searchUser(this.searchUser).then((res) => {
        this.loading = false;
        this.userData = res.data;
        for (let i = 0; i < this.userData.length; i++) {
          this.userData[i].NX = this.yearsBetweenDates(
            this.userData[i].startDate.split("T")[0],
            this.nowDate
          );
        }
      });
    },
    personSubmit(formName, fileName) {
      if (this.person.idNumber != '' && this.person.idNumber.length != 18) {
        this.$message.warning("请输入正确的身份证号");
        return;
      }
      if (this.person.phone.length != 11) {
        this.$message.warning("请输入正确的手机号码")
        return;
      }
      if (this.person.bornDate == '') {
        this.$message.warning("请选择出生日期");
        return;
      }
      if (this.person.train == '否') {
        this.person.certificate = ''
      }
      let yz = false
      if (fileName || this.person.train == '否') {
        yz = true
      }
      this.person.fileName = fileName
      this.person.userID = this.randomNumber(5, 9)
      this.$refs[formName].validate((valid) => {
        if (yz) {
          addUser(this.person).then((res) => {
            if (res.data > 0) {
              this.$message.success("添加成功");
              this.addDialog = false;
              this.person = {
                hospitalNumber: this.loginUser.HospitalNumber,
                userID: "",
                name: "",
                phone: "",
                gender: "男",
                age: "",
                profession: "",
                startDate: "",
                zc: "",
                duties: "",
                train: "是",
                lastTraining: "",
                certificate: "",
                fileName: "",
              };
              this.search();
            } else this.$message.warning("添加失败")
          });
        } else {
          if (valid) {
            addUser(this.person).then((res) => {
              if (res.data > 0) {
                this.$message.success("添加成功");
                this.addDialog = false;
                this.person = {
                  hospitalNumber: this.loginUser.HospitalNumber,
                  userID: "",
                  name: "",
                  phone: "",
                  gender: "男",
                  age: "",
                  profession: "",
                  startDate: "",
                  zc: "",
                  duties: "",
                  train: "是",
                  lastTraining: "",
                  certificate: "",
                  fileName: "",
                };
                this.search();
              } else this.$message.warning("添加失败")
            });
          } else {
            this.$message.warning("请将人员信息填写完整!")
            return false
          }
        }
      });
    },
    getAllDuties() {
      getDuties({ dutiesName: "" }).then((res) => {
        this.allDuties = res.data;
      });
    },
    getProfessional() {
      getProfessional({ name: "" }).then((res) => {
        this.professional = res.data;
      });
    },
    getProfessionalPost() {
      getProfessionalPost({ name: "" }).then((res) => {
        this.professionalPost = res.data;
      });
    },
    pageChange(page) {
      this.page = page;
    },
    yearsBetweenDates(date1, date2) {
      const years =
        new Date(date2).getFullYear() - new Date(date1).getFullYear();
      // 如果date2在1月1日之后，则年份需要减去1
      if (
        new Date(date2).getMonth() < new Date(date1).getMonth() ||
        (new Date(date2).getMonth() === new Date(date1).getMonth() &&
          new Date(date2).getDate() < new Date(date1).getDate())
      ) {
        return years - 1;
      }
      return years;
    },
    getNowDate() {
      const date = new Date();
      const year = date.getFullYear();
      const month = date.getMonth() + 1;
      const day = date.getDate();
      this.nowDate = `${year}-${month}-${day}`;
    },
    // 生成印章
    getChapter() {
      var canvas = document.getElementById("chapterCanvas");
      var context = canvas.getContext("2d");
      var text = "xxx专用章";
      var companyName = "四川省医院感染管理质量控制中心";
      //  context.translate(0, 0);
      // context.clearRect(0, 0, 200, 200);//清除整个画布
      // 绘制印章边框
      var width = canvas.width / 2;
      var height = canvas.height / 2;
      context.lineWidth = 3;
      context.strokeStyle = "#cf0c0c";
      context.beginPath();
      context.arc(width, height, 60, 0, Math.PI * 2); //宽、高、半径
      context.stroke();

      //画五角星
      create5star(context, width, height, 15, "#cf0c0c", 0);

      // 绘制印章名称
      context.font = "20px 宋体";
      context.textBaseline = "middle"; //设置文本的垂直对齐方式
      context.textAlign = "center"; //设置文本的水平对对齐方式
      context.lineWidth = 1;
      context.strokeStyle = "#cf0c0c";
      // context.strokeText(text, width, height + 30); // 名称 xx专用章

      // 绘制印章单位
      context.translate(width, height); // 平移到此位置,
      context.font = "20px 宋体";
      var count = companyName.length; // 字数
      var angle = (5 * Math.PI) / (3 * (count - 1)); // 字间角度
      var chars = companyName.split("");
      var c;
      for (var i = 0; i < count; i++) {
        c = chars[i]; // 需要绘制的字符
        if (i == 0) {
          context.rotate((4 * Math.PI) / 6); // 文字起始位置
        } else {
          context.rotate(angle);
        }

        context.save();
        context.translate(45, 0); // 平移到此位置,此时字和x轴垂直，公司名称和最外圈的距离
        context.rotate(Math.PI / 2); // 旋转90度,让字平行于x轴
        context.strokeText(c, 0, 0); // 此点为字的中心点
        context.restore();
      }

      //绘制五角星
      function create5star(context, sx, sy, radius, color, rotato) {
        context.save();
        context.fillStyle = color;
        context.translate(sx, sy); //移动坐标原点
        context.rotate(Math.PI + rotato); //旋转
        context.beginPath(); //创建路径
        var x = Math.sin(0);
        var y = Math.cos(0);
        var dig = (Math.PI / 5) * 4;
        for (var i = 0; i < 5; i++) {
          //画五角星的五条边
          var x = Math.sin(i * dig);
          var y = Math.cos(i * dig);
          context.lineTo(x * radius, y * radius);
        }
        context.closePath();
        context.stroke();
        context.fill();
        context.restore();
      }
    },
  },
};
</script>

<style scoped>
.user-search {
  margin-top: 20px;
}

.userRole {
  width: 100%;
}

::v-deep .el-dialog__body {
  padding: 0px;
  display: flex;
  justify-content: center;
}

#pdfDom {
  /* 要想pdf周边留白，要在这里设置 */
  /* padding: 20px; */
  width: 750px;
}

.proBox {
  /* 奖状的模板 */
  background: url("../../components/zs/zs.png") no-repeat;

  background-size: cover;
  width: 870px;
  height: 620px;
  padding: 50px 54px;
  box-sizing: border-box;
  margin: 0 auto;
  position: relative;
  color: #000;
  font-family: SimSun;
}

.tit {
  color: #cf0c0c;
  font-size: 30px;
  font-weight: 700;
  position: relative;
  top: -6px;
  left: 8px;
  letter-spacing: 20px;
  font-family: STHeiti;
  margin: 20px 0;
}

.proid {
  text-align: right;
  margin: 0;
  font-weight: 500;
}

.con {
  font-size: 20px;
  font-weight: 700;
  text-align: left;
  margin: 35px 0 0 10px;
  line-height: 32px;
  text-indent: 2em;
}

.con-text {
  font-size: 20px;
  font-weight: 700;
  text-align: left;
  margin: 40px 0 0 10px;
  line-height: 32px;
  text-indent: 5em;
}

.con-name {
  /* font-family: 华文行楷, STXingkai; */
  border-bottom: 2px solid #000;
}

.con-height {
  font-family: 华文行楷, STXingkai;
  font-weight: 700;
  font-size: 2em;
}

.con-unit {
  font-size: 18px;
  font-weight: 700;
  position: absolute;
  right: 80px;
  bottom: 100px;
  text-align: center;
  letter-spacing: 3px;
}

.con-unit p {
  margin: 5px 0;
}

.con-footer {
  font-size: 18px;
  font-weight: 700;
  position: absolute;
  bottom: 45px;
  left: 0;
  right: 0;
  text-align: center;
}

.chapter {
  border-radius: 50%;
  position: absolute;
  bottom: 75px;
  right: 120px;
}

.button {
  /* margin: 50px 50px; */
  position: absolute;
  left: 60px;
  font-family: 华文行楷, STXingkai;
  font-weight: 300;
  /* font-size: 2em; */
}
</style>



// WEBPACK FOOTER //
// src/views/system/user.vue